import React from "react";
import Button from "../Recommendations/components/Button/Button";
import notificationsIco from "../../../../assets/notificationsIco.svg";
import { useOutletContext } from "react-router-dom";

function PlanNotice({ title, description, buttonText, onClick }) {
  return (
    <div className="careers">
      <div className="careers__title-container">
        <img src={notificationsIco} alt="" />
        <p className="careers__title">{title}</p>
      </div>
      <p className="careers__description">{description}</p>
      <Button className="m-auto" active={false} text={buttonText} handeClick={onClick} />
    </div>
  );
}

function PlanEmptyState({ hasCompletedAssessment, hasSavedCareer, onGeneratePlan, onStartNew }) {
    const { user } = useOutletContext();
  return (
    <>
      {!hasCompletedAssessment ? (
        <PlanNotice
          title="Take the assessment to build your plan"
          description={user?.pricing_plan ? '':"Your action plan is based on your results. Start with a quick assessment to get personalized career recommendations."}
          buttonText="Start Test Now"
          onClick={() => onStartNew(false)}
        />
      ) : !hasSavedCareer ? (
        <PlanNotice
          title="Pick a few careers to build your plan"
          description="Your plan is based on careers you’re interested in. Save 2–3 careers to get started."
          buttonText="Go to Recommendations"
          onClick={() => onStartNew(true)}
        />
      ) : (
        <Button className="m-auto actionPlan__generate" active={false} text="Generate My Plan" handeClick={onGeneratePlan} />
      )}
    </>
  );
}

export default React.memo(PlanEmptyState);
